// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideMenu_wrapper__2sxX2","container":"SideMenu_container__K0PCv","indicatorWrapper":"SideMenu_indicatorWrapper__2f9Ek"};